<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="800">
      <v-form ref="SkillAssessForm" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action }} Skills Assessment</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 900px" class="">
            <v-container class="pa-5">
              <v-row>
                <!-- <v-col
                  v-if="action != 'View'"
                  cols="12"
                  style="border: 1px solid grey"
                  class="rounded-lg pa-2 mx-3 my-4"
                >
                  <div class="my-1">Programs</div>
                  <div class="mt-1 d-flex justify-space-around">
                    <div v-for="i in programs" :key="i.program_id">
                      <v-checkbox
                        :label="i.program_name"
                        hide-details
                        v-model="i.isSelected"
                        :checked="i.isSelected"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-col> -->
                <v-col cols="12" v-if="action == 'View'">
                  <v-text-field
                    v-model="getProgramName"
                    label="Title"
                    readonly
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="title"
                    :rules="[formRules.required]"
                    label="Title"
                    :readonly="action == 'View'"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    density="compact"
                    label="Select Category (Select 'Add Category' category is not on the list)"
                    v-model="category"
                    item-value="category"
                    item-title="category"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    chips
                    :readonly="action != 'Add'"
                    :items="categoryList"
                  ></v-autocomplete>
                  <v-text-field
                    v-model="new_category"
                    v-if="category == 'Add Category'"
                    :rules="
                      category == 'Add Category' ? [formRules.required] : []
                    "
                    label="Category"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    type="number"
                    v-model="time_limit"
                    :rules="[formRules.required, formRules.noDecimal]"
                    label="Time Limit (In minute)"
                    :readonly="action == 'View'"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="action != 'View'">
                  <v-btn
                    v-if="!aiken_file"
                    :color="$vuetify.theme.themes.light.submitBtnsGreen"
                    @click="addFileDialog = true"
                    >Add Question in Aiken Format</v-btn
                  >

                  <v-dialog
                    v-model="addFileDialog"
                    width="600"
                    transition="dialog-top-transition"
                  >
                    <v-form ref="addFileRef" @submit.prevent>
                      <v-card prepend-icon="mdi-upload" title="Upload File">
                        <v-card-text class="">
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-file-input
                                  v-model="aiken_file"
                                  :rules="[formRules.required]"
                                  variant="outlined"
                                  density="compact"
                                  accept=".txt"
                                  label="File input"
                                ></v-file-input>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-divider></v-divider>

                        <v-card-actions class="pa-2 mr-4">
                          <v-spacer></v-spacer>
                          <v-btn
                            color="red"
                            outlined
                            @click="addFileDialog = false"
                          >
                            <v-icon>mdi-close-circle-outline</v-icon>
                            Cancel
                          </v-btn>
                          <v-btn
                            :color="$vuetify.theme.themes.light.submitBtns"
                            class="white--text"
                            density="comfortable"
                            variant="flat"
                            @click="handleFileInput()"
                          >
                            <v-icon>mdi-check-circle</v-icon>
                            save
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-form>
                  </v-dialog>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <div v-if="questions.length > 0">
                    <h2>
                      {{
                        action != "View" && action != "Update" ? "Parsed" : ""
                      }}
                      Questions:
                    </h2>
                    <div
                      v-for="(q, index) in questions"
                      :key="index"
                      class="question-block"
                    >
                      <div class="border border-1 pa-2 my-2 rounded-lg">
                        <div
                          class="text-subtitle-2 d-flex justify-space-between align-center"
                        >
                          <div class="font-weight-bold text-grey">
                            Q {{ index + 1 }}
                          </div>
                          <div class="d-flex align-center">
                            <!-- <v-btn
                              icon
                              color="grey"
                              size="small"
                              variant="text"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn> -->
                            <v-btn
                              icon
                              color="grey"
                              size="small"
                              variant="text"
                              @click="removeQuestion(q, index)"
                            >
                              <v-icon>mdi-trash-can</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <div class="">
                          <p style="white-space: pre-wrap">{{ q.question }}</p>
                        </div>
                        <div
                          class="text-grey text-caption"
                          style="border-left: 1px solid #10b981"
                        >
                          &nbsp;&nbsp;
                          <span style="color: #10b981"
                            ><strong>Correct Answer:</strong>
                            {{ q.answer }}</span
                          >
                        </div>
                      </div>

                      <div>
                        <div
                          class="text-subtitle-1 font-weight-bold text-grey my-1"
                        >
                          Options
                        </div>
                        <div
                          v-for="(option, key) in q.options"
                          :key="key"
                          class="border border-1 pa-2 my-2 rounded-lg"
                        >
                          <div
                            class="text-grey text-subtitle-1"
                            v-if="action != 'View' && action != 'Update'"
                          >
                            <span>{{ key }}</span
                            >&nbsp;&nbsp;{{ option }}
                          </div>
                          <div class="text-grey text-subtitle-1" v-else>
                            <span>{{ option.option_no }}</span
                            >&nbsp;&nbsp;{{ option.option_desc }}
                          </div>
                        </div>
                      </div>

                      <!-- <p><strong>Question:</strong></p>
                      <p style="white-space: pre-wrap">{{ q.question }}</p> -->
                      <!-- <ul v-if="action != 'View' && action != 'Update'">
                        <li v-for="(option, key) in q.options" :key="key">
                          {{ key }}) {{ option }}
                        </li>
                      </ul> -->
                      <!-- <ul v-else>
                        <li v-for="(option, key) in q.options" :key="key">
                          {{ option.option_no }})
                          {{ option.option_desc }}
                        </li>
                      </ul> -->

                      <hr />
                    </div>
                  </div>
                  <p v-else-if="!fileLoaded && action != 'View'">
                    Please upload an Aiken (.txt) file.
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="action == 'Add' ? save() : update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              {{ action == "Add" ? "Add" : "Update" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
    programs: Array,
  },
  data() {
    return {
      dialog: false,
      showDatePicker: false,
      addFileDialog: false,
      program_for: [],
      categoryList: [],
      category: null,
      new_category: null,
      title: null,
      questions: [],
      allQuestions: [],
      orgsList: [],
      orgID: null,
      aiken_file: null,
      file_desc: null,
      valid_until: null,
      name: null,
      email: null,
      address: null,
      program_tied_id: null,
      program_to_tie: [],
      btnLoading: false,
      programsList: [],
      time_limit: null,
      deletedFile: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      fileLoaded: false,
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("sdasd", data.skill_assessment_ids);
        this.initialize();
        this.$refs.SkillAssessForm.resetValidation();
        if (data.title) {
          this.title = data.title;
          this.time_limit = data.time_limit;
          this.category = data.category;
          this.getQuestionAndAnswer(data.skill_assessment_ids[0]);
        } else {
          this.$refs.SkillAssessForm.reset();
          this.$refs.SkillAssessForm.resetValidation();
          this.questions = [];
          this.aiken_file = null;
        }
      },
      deep: true,
    },
  },
  computed: {
    getProgramsHandled() {
      let arr = [];
      console.log("STOTE", this.$store.state.user.user);
      let handled = this.$store.state.user.user.programs_handled;
      if (this.programsList.length > 0) {
        for (let j = 0; j < handled.length; j++) {
          for (let i = 0; i < this.programsList.length; i++) {
            if (handled[j] == this.programsList[i].id) {
              arr.push(this.programsList[i]);
            }
          }
        }
      }
      return arr;
    },
    getProgramName() {
      let name = "";
      for (let i = 0; i < this.programs.length; i++) {
        if (this.data.program_id == this.programs[i].program_id) {
          name = this.programs[i].program_name;
        }
      }
      return name;
    },
  },
  methods: {
    initialize() {
      let handled = this.$store.state.user.user.programs_handled;

      for (let i = 0; i < handled.length; i++) {
        this.program_for.push({
          program_id: handled[i],
          isSelected: true,
        });
      }

      console.log("handled", handled);
      this.getPrograms();
      this.getOrganizations();
      this.getCategories();
    },

    getCategories() {
      this.axiosCall("/skill-assessement/getCategories", "GET").then((res) => {
        if (res) {
          console.log(res.data);
          this.categoryList = res.data;
          this.categoryList.push("Add Category");

          //   this.loading = false;
        }
      });
    },

    handleFileInput() {
      if (this.aiken_file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          this.parseAikenContent(e.target.result);
          this.fileLoaded = true;
          this.addFileDialog = false;
        };
        reader.readAsText(this.aiken_file);
      }
    },

    parseAikenContent(content) {
      //   console.log("called", content);
      const allLines = content
        .split("\n")
        .map((line) => line.trimEnd())
        .filter((line) => line.length > 0);

      let currentQuestion = null;
      let newQuestions = [];
      let isReadingQuestion = false;

      allLines.forEach((line) => {
        // Check for Answer line (ANSWER: X)
        const trimmedLine = line.trim();

        if (line.startsWith("ANSWER:")) {
          if (currentQuestion) {
            currentQuestion.answer = trimmedLine.split(":")[1].trim();
            newQuestions.push(currentQuestion);
            currentQuestion = null;
            isReadingQuestion = false;
          }
        }
        // Check for Options (A) Option text, B. Option text)
        else if (/^[A-Z][.)]\s/.test(trimmedLine)) {
          if (currentQuestion) {
            isReadingQuestion = false; // Stop reading question text
            const match = line.match(/^([A-Z])[.)]\s(.*)/);
            if (match) {
              currentQuestion.options[match[1]] = match[2];
            }
          }
        }
        // If we're reading a question or starting a new one
        else {
          // If we have a current question and we're still reading it (no options yet)
          if (currentQuestion && isReadingQuestion) {
            // Append to existing question (multi-line)
            currentQuestion.question += "\n " + line;
          } else {
            // Start a new question
            if (currentQuestion) {
              // This shouldn't happen with proper format, but save previous if exists
              newQuestions.push(currentQuestion);
            }
            currentQuestion = {
              question: line,
              options: {},
              answer: "",
            };
            isReadingQuestion = true;
          }
        }
      });

      // Add the last question if any
      if (currentQuestion) {
        newQuestions.push(currentQuestion);
      }

      this.questions = newQuestions;
      console.log(this.questions);
    },

    getQuestionAndAnswer(skill_assessment_id) {
      this.questions = [];
      this.axiosCall(
        "/skill-assessement/getQuestionAndAnswer/" + skill_assessment_id,
        "GET",
      ).then((res) => {
        if (res) {
          console.log("QUESTIONS", res.data);
          this.questions = res.data;
          //   this.loading = false;
        }
      });
    },
    saveDate() {
      if (this.valid_until) {
        this.valid_until = this.formatDate3(this.valid_until);
      }
      this.showDatePicker = false;
    },

    deleteFile() {
      console.log(typeof this.moa_file);
      if (typeof this.moa_file == "string") {
        this.deletedFile = this.moa_file;
      }

      this.moa_file = null;
      this.file_desc = null;
      this.valid_until = null;
    },

    async save() {
      let formValid = await this.$refs.SkillAssessForm.validate();

      if (formValid.valid) {
        if (this.questions.length > 0) {
          this.axiosCall("/skill-assessement", "POST", {
            title: this.title,
            skill_assessment_group_id: this.data.skill_assessment_group_id,
            category:
              this.category == "Add Category"
                ? this.new_category
                : this.category,
            time_limit: this.time_limit,
            programs_for: JSON.stringify(this.programs),
            questions: JSON.stringify(this.questions),
          }).then((res) => {
            if (res.data.status == 201) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
              this.btnLoading = false;
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          });
        }
      }
    },

    async update() {
      let formValid = await this.$refs.SkillAssessForm.validate();

      if (formValid.valid) {
        if (this.questions.length > 0) {
          this.axiosCall("/skill-assessement/update", "POST", {
            title: this.title,
            category:
              this.category == "Add Category"
                ? this.new_category
                : this.category,
            time_limit: this.time_limit,
            skill_assessment_ids: JSON.stringify(
              this.data.skill_assessment_ids,
            ),
          }).then((res) => {
            if (res.data.status == 200) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
              this.btnLoading = false;
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          });
        }
      }
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.program_id;
      this.initialize();
    },

    async save_file() {
      let valid = await this.$refs.addFileRef.validate();
      if (valid.valid) {
        this.addFileDialog = false;
      }
    },

    UpdateInfo() {
      let data = {
        fname: this.fname,
        mname: this.mname,
        lname: this.lname,
      };
      this.axiosCall(
        "/user-details/updateUserInfo/" +
          this.data.id +
          "/" +
          JSON.stringify(data),
        "POST",
        data,
      ).then((res) => {
        if (res.data.status == 200) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = res.data.message;
          this.fadeAwayMessage.header = "System Message";
          this.closeD();
          this.refresh();
        } else {
          this.isLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = res.data.message;
          this.fadeAwayMessage.header = "System Message";
          this.animated = true;
        }
      });
    },

    removeQuestion(item, index) {
      let confirm = window.confirm(
        "Are you sure you want to delete this question?",
      );
      if (confirm) {
        if (!item.id) {
          this.questions.splice(index, 1);
        } else {
          this.axiosCall("/skill-assessement/remove_question", "POST", {
            skq_ids: JSON.stringify(item.skq_ids),
          }).then((res) => {
            if (res.data.status == 200) {
              this.questions.splice(index, 1);
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            } else {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          });
        }
      }
    },
    closeD() {
      eventBus.emit("closeSkillAssessmentDialog", true);
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },

    getOrganizations() {
      this.axiosCall(
        // "/organization/selection/" + this.$store.state.user.program_id,
        "/organization/selection/" +
          this.$store.state.user.user.programs_handled[0],
        "GET",
      ).then((res) => {
        this.orgsList = res.data;
        this.orgsList.push({ id: -1, name: "Add New Organization/Agency" });
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
